import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrHoverButton from "UI/FnrHoverButton";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import { colors } from "UI/colors";

ShowCancellationsButton.propTypes = {
  showCancellations: PropTypes.bool,
  setShowCancellations: PropTypes.func,
  cancelledRespondents: PropTypes.array,
};

export default function ShowCancellationsButton({
  showCancellations,
  setShowCancellations,
  cancelledRespondents,
}) {
  const handleClick = () => {
    setShowCancellations(!showCancellations);
  };

  if (!cancelledRespondents?.length) {
    return null;
  }

  return (
    <Wrapper>
      <FnrHoverButton onClick={handleClick}>
        <Content $on={showCancellations}>
          {showCancellations ? (
            <FnrIcon fas fa-check-square />
          ) : (
            <FnrIcon far fa-square />
          )}
          <Label>Show cancellations</Label>
        </Content>
      </FnrHoverButton>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 60px;
  display: inline-block;
`;

const Label = styled.div`
  margin-left: 8px;
`;

const Content = styled.div`
  font-weight: 400;
  display: flex;
  align-items: center;
  color: ${({ $on }) => ($on ? colors.fnBlue : "#59706a")};
  font-size: 14px;
`;
